import React from 'react';
export function useSortedEvents(events, ascending) {
    return React.useMemo(() => {
        const sorted = [...events];
        sorted.sort((a, b) => {
            const comparison = a.date.compareTo(b.date);
            return ascending ? comparison : -comparison;
        });
        return sorted;
    }, [events, ascending]);
}
//# sourceMappingURL=useSortedEvents.js.map